/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliverySlotSchema = z.object({
	time: z.string().describe("Для показа: «13:30»."),
	start: z.string().describe("Время с датой для оформления заказа: после полуночи дата уже следующая."),
});
